export default function objectReduce(object, iterator, initialValue) {
  for (var key in object) {
    initialValue = iterator(initialValue, object[key], key);
  }

  return initialValue;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/objectReduce.js
// module id = 285
// module chunks = 0